// ── THE UNIT KEY — one rule for "which insurance unit is this row on" ──────────
//
// Two readers ask it: productionEvidence files an appraisal under the COUNTY its unit sits
// in, and fieldCoverage places an appraisal on a FIELD of its unit. They were two closures
// with the same idea until 2026-10-26 (Red Dawn), and two copies of a key is how one side
// comes to offer a match the other can never make — so the rule lives here once.
//
// A unit number is digits. "1.0000 BU" is an extraction defect, not a unit, and is refused
// (null) so the row falls to the next rung and is COUNTED rather than quietly matching
// nothing. Leading zeros are stripped because the worksheet pads them ("0002") and
// policy_fields does not always. A missing basic unit is NEVER a key — a blank must not
// join to a blank.

"use strict";

const uz = (v) => String(v == null ? "" : v).trim().replace(/^0+(?=\d)/, "");

// policy_fields: unit_number "0002", sub_unit "0057"  ->  "2|57"
function pfUnitKey(p) {
  const u = uz(p && p.unit_number);
  return /^\d+$/.test(u) ? u + "|" + uz(p && p.sub_unit) : null;
}

// silage_appraisals: unit_number "0002-0057-000"  ->  "2|57". Only the first two segments
// carry anything — measured, the third is "0" on all 77 well-formed rows.
function apprUnitKey(a) {
  const parts = String((a && a.unit_number) ?? "").trim().split("-");
  const u = uz(parts[0]);
  return /^\d+$/.test(u) ? u + "|" + uz(parts[1]) : null;
}

// For a sentence: "2|57" -> "2-57".
const unitLabel = (key) => (key == null ? null : String(key).replace("|", "-"));

module.exports = { pfUnitKey, apprUnitKey, unitLabel };
